import { render, staticRenderFns } from "./ApplicationsList.vue?vue&type=template&id=57840057&scoped=true"
import script from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ApplicationsList.vue?vue&type=style&index=0&id=57840057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57840057",
  null
  
)

export default component.exports